"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModalStyles = exports.modalVars = exports.modalRootVars = exports.modalCommon = void 0;
var _constants = require("../../components/constants");
var _Modal = require("../../components/Modal/Modal");
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _getRgbaFromHex = _interopRequireDefault(require("../../utils/getRgbaFromHex"));
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var modalCommon = exports.modalCommon = ["height", "width", "zIndex", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft"];
var modalVars = exports.modalVars = (0, _initVars.default)({
  applied: modalCommon
});
var modalRootVars = exports.modalRootVars = (0, _initVars.default)({
  variables: [{
    key: "rootHeight",
    defaultUnit: "px"
  }, {
    key: "defaultCloseButtonBackground"
  }]
});
var styles = function styles(theme) {
  return {
    variables: modalVars.styles,
    rootVariables: modalRootVars.styles,
    defaultModalRootStyles: {
      overscrollBehavior: "contain",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "fixed",
      height: modalRootVars.get("rootHeight", "100%"),
      width: "100vw",
      overflow: "hidden",
      top: 0,
      // eslint-disable-next-line @atg/css-rtl-support
      left: 0,
      fontFamily: theme.typography.fontFamily,
      color: theme.colors.baseContrast070,
      zIndex: _constants.Z_INDEX.ModalRoot,
      "& h1": {
        color: theme.colors.baseContrast085,
        marginTop: 0,
        fontSize: theme.typography.fontSize + 10
      }
    },
    defaultModalOverlayStyles: {
      height: "100%",
      width: "100vw",
      position: "fixed",
      top: 0,
      // eslint-disable-next-line @atg/css-rtl-support
      left: 0,
      willChange: "opacity",
      transition: "opacity 300ms",
      zIndex: _constants.Z_INDEX.ModalOverlay,
      opacity: 0,
      backgroundColor: (0, _getRgbaFromHex.default)(theme.colors.baseShadow, 0.5)
    },
    modalOverlayOpen: {
      opacity: 1
    },
    defaultModalBoxStyles: {
      overscrollBehavior: "contain",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      position: "absolute",
      top: "auto",
      bottom: "auto",
      left: "auto",
      right: "auto",
      height: "auto",
      maxHeight: "100%",
      maxWidth: "calc(100% - ".concat(theme.spacing.base * 4, "px)"),
      overflow: "auto",
      willChange: "transform",
      padding: theme.spacing.base * 6,
      borderRadius: 2,
      borderImageSlice: 1,
      backgroundOrigin: "border-box",
      backgroundClip: "border-box",
      boxSizing: "border-box",
      fontFamily: "inherit",
      outline: "none",
      zIndex: _constants.Z_INDEX.ModalBox,
      boxShadow: "0 ".concat(theme.spacing.base * 3, "px ").concat(theme.spacing.base * 3, "px 0 ").concat((0, _getRgbaFromHex.default)(theme.colors.baseShadow, 0.3), ", 0 0 ").concat(theme.spacing.base * 3, "px 0 ").concat((0, _getRgbaFromHex.default)(theme.colors.baseShadow, 0.22)),
      borderImageSource: "linear-gradient(to bottom, ".concat(theme.colors.baseContrast030, " 5%, transparent 20%, transparent)"),
      borderStyle: "solid",
      background: theme.colors.baseContrast015,
      borderWidth: 1,
      "& > *": {
        outline: 0
      }
    },
    fullScreen: {
      maxWidth: "100%",
      width: "100vw",
      height: "100vh",
      borderRadius: 0,
      border: "none"
    },
    gradient: {
      borderStyle: "none",
      background: "linear-gradient(rgba(0, 0, 0, 0.3), rgb(0, 0, 0) 37%)",
      borderWidth: 0,
      "& > $defaultCloseButtonStyles": {
        backgroundColor: (0, _getRgbaFromHex.default)(theme.colors.baseShadow, 0.4),
        "& svg": {
          fill: theme.colors.textOnDark,
          "&:hover": {
            fill: theme.colors.textOnDark
          }
        }
      }
    },
    small: {
      maxWidth: 496,
      width: 320,
      padding: theme.spacing.base * 3
    },
    medium: {
      minWidth: 320,
      width: 448
    },
    large: {
      minWidth: 448,
      width: 768
    },
    modalOpen: {
      animation: _Modal.ModalOpenAnimationTime + "ms linear normal forwards $ModalOpen"
    },
    modalClose: {
      animation: _Modal.ModalCloseAnimationTime + "ms linear normal forwards $ModalClose"
    },
    "@keyframes ModalOpen": {
      "0%": {
        transform: "translateY(-80px)",
        opacity: 0
      },
      "60%": {
        transform: "translateY(14px)",
        opacity: 1
      },
      "100%": {
        transform: "translateY(0px)"
      }
    },
    "@keyframes ModalClose": {
      "0%": {
        transform: "translateY(0px)",
        opacity: 1
      },
      "100%": {
        transform: "translateY(-80px)",
        opacity: 0
      }
    },
    defaultCloseButtonStyles: {
      padding: 0,
      position: "absolute",
      top: theme.spacing.base,
      insetInlineEnd: theme.spacing.base,
      zIndex: _constants.Z_INDEX.ModalCloseButton,
      backgroundColor: modalRootVars.get("defaultCloseButtonBackground"),
      transition: "200ms ease all",
      borderRadius: "unset",
      "& svg": {
        fill: theme.colors.baseContrast100,
        "&:hover": {
          fill: theme.colors.baseContrast100
        }
      }
    }
  };
};
var useModalStyles = exports.useModalStyles = (0, _createUseStyles.default)(styles, {
  name: "Modal"
});